import serviceCopy from './service-copy.json' with {type:'json'};
import languageNames from './language-names.json' with {type:'json'};
import tamilUI from './ta-ui.json' with {type:'json'};
import spanishUI from './es-ui.json' with {type:'json'};
import hindiUI from './hi-ui.json' with {type:'json'};
import frenchUI from './fr-ui.json' with {type:'json'};
import koreanUI from './ko-ui.json' with {type:'json'};
import japaneseUI from './ja-ui.json' with {type:'json'};
import germanUI from './de-ui.json' with {type:'json'};
import mandarinUI from './zh-ui.json' with {type:'json'};
import arabicUI from './ar-ui.json' with {type:'json'};
import russianUI from './ru-ui.json' with {type:'json'};
import teluguUI from './te-ui.json' with {type:'json'};
import portugueseUI from './pt-ui.json' with {type:'json'};
import bengaliUI from './bn-ui.json' with {type:'json'};
import indonesianUI from './id-ui.json' with {type:'json'};
import turkishUI from './tr-ui.json' with {type:'json'};
import malayalamUI from './ml-ui.json' with {type:'json'};
import vietnameseUI from './vi-ui.json' with {type:'json'};
import thaiUI from './th-ui.json' with {type:'json'};
import italianUI from './it-ui.json' with {type:'json'};
import {accountCopy} from '../auth/copy.ts';
import {loginCopy} from '../auth/login-copy.ts';
export type SupportedLanguage='en'|'ta'|'es'|'hi'|'fr'|'ko'|'ja'|'de'|'zh'|'ar'|'ru'|'te'|'pt'|'bn'|'id'|'tr'|'ml'|'vi'|'th'|'it';
export type Dictionary=Record<string,string>;
export const languages=[
 {code:'en',name:'English',native:'English'}, {code:'es',name:'Spanish',native:'Español'},
 {code:'fr',name:'French',native:'Français'}, {code:'ja',name:'Japanese',native:'日本語'},
 {code:'ko',name:'Korean',native:'한국어'}, {code:'ar',name:'Arabic',native:'العربية'},
 {code:'hi',name:'Hindi',native:'हिन्दी'}, {code:'zh',name:'Mandarin',native:'中文'},
 {code:'ta',name:'Tamil',native:'தமிழ்'}, {code:'te',name:'Telugu',native:'తెలుగు'},
 {code:'ru',name:'Russian',native:'Русский'}, {code:'pt',name:'Portuguese',native:'Português'},
 {code:'de',name:'German',native:'Deutsch'}, {code:'id',name:'Indonesian',native:'Bahasa Indonesia'},
 {code:'bn',name:'Bengali',native:'বাংলা'}, {code:'tr',name:'Turkish',native:'Türkçe'},
 {code:'ml',name:'Malayalam',native:'മലയാളം'},
 {code:'vi',name:'Vietnamese',native:'Tiếng Việt'},
 {code:'th',name:'Thai',native:'ไทย'},
 {code:'it',name:'Italian',native:'Italiano'},
] as const;
export type LanguageCode=typeof languages[number]['code'];
export const isAvailableLanguage=(code:string):code is SupportedLanguage=>languages.some(language=>language.code===code);
export const languageDirection=(code:string)=>code==='ar'?'rtl':'ltr';
const normalize=(value:string)=>value.trim().toLowerCase().replace(/[’‘]/g,"'").replace(/[–—]/g,'-').replace(/…/g,'...').replace(/\s+/g,' ');
const dictionaries:Record<SupportedLanguage,Dictionary>={en:{},ta:tamilUI,es:spanishUI,hi:hindiUI,fr:frenchUI,ko:koreanUI,ja:japaneseUI,de:germanUI,zh:mandarinUI,ar:arabicUI,ru:russianUI,te:teluguUI,pt:portugueseUI,bn:bengaliUI,id:indonesianUI,tr:turkishUI,ml:malayalamUI,vi:vietnameseUI,th:thaiUI,it:italianUI};
for(const [code,copy] of Object.entries(accountCopy))Object.assign(dictionaries[code as SupportedLanguage],copy);
for(const [code,copy] of Object.entries(loginCopy))Object.assign(dictionaries[code as SupportedLanguage],copy);
for(const [code,copy] of Object.entries(serviceCopy))Object.assign(dictionaries[code as SupportedLanguage],copy);
for(const [code,copy] of Object.entries(languageNames))Object.assign(dictionaries[code as SupportedLanguage],copy);
const uiLookups=Object.fromEntries(Object.entries(dictionaries).map(([code,dictionary])=>[code,new Map(Object.entries(dictionary).map(([key,value])=>[normalize(key),value]))]));
export function translateText(language:SupportedLanguage,content:Dictionary,source:string|number|null|undefined,values:Record<string,string|number>={}):string{
 if(source===null||source===undefined)return '';
 const en=String(source),trimmed=en.trim();
 const dictionary=dictionaries[language];
 let value=language!=='en'?(dictionary[en]??dictionary[trimmed]??uiLookups[language].get(normalize(en))??content[en]??content[trimmed]??en):en;
 if(language!=='en'&&value!==en&&trimmed!==en)value=(en.match(/^\s*/)?.[0]??'')+value+(en.match(/\s*$/)?.[0]??'');
 return value.replace(/\{(\w+)\}/g,(match,key)=>Object.hasOwn(values,key)?String(values[key]):match);
}
